import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Link, withRouter} from "react-router-dom";
import {checkBaseInfo, checkRefInfo} from "helpers/models/productVerification";

import {getProductById, setProduct, newProduct, editProduct, checkPendingUpdates, syncPendingProductUpdates} from "../../../redux/actions/product";

import {Grid, Row, Col} from "react-bootstrap";

import Button from "components/CustomButton/CustomButton.jsx";

import ProductBaseForm from 'app-components/Products/Form/ProductBaseForm.jsx';
import ProductReferenceForm from 'app-components/Products/Form/ProductReferenceForm.jsx';
import DeleteConfirmationModal from "components/DeleteConfirmationModal/DeleteConfirmationModal.jsx";


class ProductForm extends Component {

    constructor(props) {
        super(props);
        const id = props.match.params.id;


        // Charger le produit seulement si l'ID existe et n'est pas 'new'
        if(id && id !== '0' && id !== 'new') {
            props.getProductById(id);
        } else {
        }

        this.emptyProd = {
            profilesContreIndiquees: '',
            nomCommercialContreIndique: '',
            statutMedicament: '',
            nom: '',
            dciTags: [],
            forme: '',
            dosage: '',
            conditionnement: '',
            familleTherapeutique: '',
            classesPharmacologiques: '',
            fabricant: '',
            codeATC: '',
            liste: '',
            references: '',
            maladieTraitee: '',
            isRef: 0,
            referenceProductId: '',

            DDD: '',
            assurance: '',
            excipientEffetsNotoires: '',
            proprietes: '',
            indications: '',
            posologie: '',
            contreIndications: '',
            effetsIndesirables: '',
            precautionsEmploi: '',
            interactionsMedicamenteuses: '',
            nomAMMouEnregistrement: ''
        };

        this.state = {
            ...this.emptyProd,
            showSaveConfirm: false,
            showCancelConfirm: false,
            pendingChanges: false,
            formData: null,
            loading: false,
            formErrors: [],
            showSuccessMessage: false, // AJOUT: État pour le message de succès
            successMessage: '', // AJOUT: Message de succès
            showSuccessModal: false, // AJOUT: Modal de succès
            successModalTitle: '', // AJOUT: Titre du modal de succès
            successModalMessage: '', // AJOUT: Message du modal de succès
            showProductNotFoundError: false, // AJOUT: Afficher erreur produit non trouvé
            productNotFoundId: '' // AJOUT: ID du produit non trouvé
        };
        this.onSubmit = this.onSubmit.bind(this);
        this.addSuccessStyles = this.addSuccessStyles.bind(this);
        this.setValue = this.setValue.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.confirmSave = this.confirmSave.bind(this);
        this.closeSuccessModal = this.closeSuccessModal.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }


    // AJOUT: Fonction pour ajouter les styles CSS
    addSuccessStyles() {
        const styleId = 'product-form-success-styles';
        if (!document.getElementById(styleId)) {
            const style = document.createElement('style');
            style.id = styleId;
            style.innerHTML = `
                @keyframes fadeInUp {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                @keyframes slideIn {
                    from { transform: translateX(100%); opacity: 0; }
                    to { transform: translateX(0); opacity: 1; }
                }
                @keyframes slideOut {
                    from { transform: translateX(0); opacity: 1; }
                    to { transform: translateX(100%); opacity: 0; }
                }
                @keyframes pulse {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.05); }
                    100% { transform: scale(1); }
                }
                .success-pulse {
                    animation: pulse 2s infinite;
                }
            `;
            document.head.appendChild(style);
        }
    }

    componentDidMount() {
        // Initialiser avec les données du produit si elles existent déjà
        if(this.props.product && this.props.product._id) {

            const cleanedData = getCleanedProduct({...this.props.product});

            this.setState({...cleanedData});
        } else {
        }

        // AJOUT: Ajouter les styles CSS pour les animations
        this.addSuccessStyles();

        // Vérifier s'il y a des mises à jour en attente
        this.props.checkPendingUpdates();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // Gestion du chargement du produit
        if(this.props.product && this.props.product._id) {
            if(!prevProps.product || prevProps.product._id !== this.props.product._id) {
                const cleanedData = getCleanedProduct({...this.props.product});

                this.setState({...cleanedData}, () => {
                });
            }
        } else if (this.props.match.params.id && this.props.match.params.id !== 'new') {
        }

        // Gestion des messages du store Redux
        if(this.props.message) {
            if(!prevProps.message || prevProps.message.timestamp !== this.props.message.timestamp) {
                // Afficher le message du store (toast/notification) uniquement
                if (this.props.showNotification) {
                    this.props.showNotification(this.props.message.message, this.props.message.status);
                }

                // Gestion spécifique des erreurs "Produit non trouvé"
                if (this.props.message.status === 'danger' &&
                    this.props.message.message.includes('Produit non trouvé')) {

                    // Attendre un peu pour laisser le temps à la notification de s'afficher
                    setTimeout(() => {
                        this.setState({
                            showProductNotFoundError: true,
                            productNotFoundId: this.props.match.params.id
                        });
                    }, 1000);
                }
            }
        }

        // Gestion des erreurs de chargement
        if(this.props.error && !prevProps.error) {
            if (this.props.showNotification) {
                this.props.showNotification(this.props.error, 'danger');
            }
            // Ne pas rediriger automatiquement, laisser l'utilisateur voir l'erreur
        }
    }

    componentWillUnmount() {
        this.props.setProduct(null);
    }

    setValue(val, index) {
        this.setState({
            [index]: val,
            pendingChanges: true
        });
    }

    handleSave(data) {
        this.setState({
            showSaveConfirm: true,
            formData: data
        });
    }

    async confirmSave() {
        const data = this.state.formData;
        if (!data) {
            if (this.props.showNotification) {
                this.props.showNotification('Aucune donnée à enregistrer', 'warning');
            }
            return;
        }

        const productId = this.props.match.params.id;

        this.setState({
            showSaveConfirm: false,
            formData: null,
            loading: true
        });

        try {
            let result;
            // ✅ CORRECTION: Déterminer le mode selon l'ID de l'URL uniquement
            const isNew = !productId || productId === '0' || productId === 'new';

            if (!isNew && productId) {
                // Mode édition - utiliser l'ID de l'URL
                result = await this.props.editProduct(productId, data);
            } else {
                // Création d'un nouveau produit
                result = await this.props.newProduct(data);
            }

            this.setState({ loading: false });

            if (result) {
                // Succès
                const productName = data.nom || this.props.product?.nom || 'le produit';
                const successTitle = isNew ? '✅ Produit créé !' : '✅ Produit mis à jour !';
                const successMessage = isNew
                    ? `Le produit "${productName}" a été créé avec succès.`
                    : `Les modifications de "${productName}" ont été enregistrées avec succès.`;

                // Afficher le modal de confirmation
                this.setState({
                    showSuccessModal: true,
                    successModalTitle: successTitle,
                    successModalMessage: successMessage,
                    pendingChanges: false
                });

                // Redirection après 3 secondes pour laisser le temps de voir le message
                setTimeout(() => {
                    this.props.history.push('/app/product/home');
                }, 3000);

            } else {
                // Échec
                this.setState({
                    formData: data,
                    pendingChanges: true
                });

                const errorMsg = 'Échec de l\'enregistrement';
                if (this.props.showNotification) {
                    this.props.showNotification(errorMsg, 'danger');
                }
            }
        } catch (error) {
            this.setState({ loading: false });

            let errorMessage = 'Une erreur est survenue lors de l\'enregistrement';
            if (error.response) {
                if (error.response.status === 404) {
                    errorMessage = 'La ressource demandée n\'a pas été trouvée. Vérifiez l\'URL ou les paramètres.';
                } else if (error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }
            }

            if (this.props.showNotification) {
                this.props.showNotification(errorMessage, 'danger');
            }

            // Garder les données pour une nouvelle tentative
            this.setState({
                formData: data,
                pendingChanges: true
            });
        }
    }

    // AJOUT: Fonction pour fermer le modal de succès
    closeSuccessModal() {
        this.setState({
            showSuccessModal: false,
            successModalTitle: '',
            successModalMessage: ''
        });
        // Rediriger immédiatement si l'utilisateur clique
        this.props.history.push('/app/product/home');
    }

    handleCancel() {
        if (this.state.pendingChanges) {
            this.setState({ showCancelConfirm: true });
        } else {
            this.props.history.goBack();
        }
    }

    prepareDataForSave() {
        const prod = {...this.state};

        // Nettoyer les données de l'état
        delete prod.showSaveConfirm;
        delete prod.showCancelConfirm;
        delete prod.pendingChanges;
        delete prod.formData;
        delete prod.formErrors;
        delete prod.loading;
        delete prod.showSuccessMessage;
        delete prod.successMessage;
        delete prod.showSuccessModal;
        delete prod.successModalTitle;
        delete prod.successModalMessage;

        // Préparer les données pour l'envoi
        prod.DCI = prod.dciTags && Array.isArray(prod.dciTags)
            ? prod.dciTags.filter(tag => tag && tag.trim()).join(",")
            : '';

        // Gérer le champ isRef
        prod.isRef = prod.isRef ? 1 : 0;
        if (prod.isRef) {
            prod.referenceProductId = '';
        }

        // Gérer les champs de type select multiple
        const processSelectMultiple = (field) => {
            if (!field) return '';

            if (Array.isArray(field)) {
                return field
                    .filter(element => element)
                    .map(element => {
                        if (typeof element === 'object') {
                            return element.label || element.value || element;
                        }
                        return element;
                    })
                    .filter(val => val && val.toString().trim())
                    .join('$');
            } else if (typeof field === 'string') {
                return field;
            }
            return '';
        };

        prod.profilesContreIndiquees = processSelectMultiple(prod.profilesContreIndiquees);
        prod.nomCommercialContreIndique = processSelectMultiple(prod.nomCommercialContreIndique);

        // Gérer le statut médicament
        if (prod.statutMedicament) {
            if (typeof prod.statutMedicament === 'object') {
                prod.statutMedicament = prod.statutMedicament.label || prod.statutMedicament.value || '';
            } else if (typeof prod.statutMedicament !== 'string') {
                prod.statutMedicament = '';
            }
        } else {
            prod.statutMedicament = '';
        }

        return prod;
    }

    onSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        const prod = this.prepareDataForSave();

        // Valider les données
        const baseInfoValid = checkBaseInfo(prod);
        const refInfoValid = prod.isRef ? checkRefInfo(prod) : true;

        if (baseInfoValid && refInfoValid) {
            this.setState({
                showSaveConfirm: true,
                formData: prod,
                pendingChanges: true
            });
        } else {
            const errors = [];
            if (!baseInfoValid) errors.push("Les informations de base ne sont pas valides.");
            if (!refInfoValid) errors.push("Les informations de référence ne sont pas valides.");

            this.setState({ formErrors: errors });
            if (this.props.showNotification) {
                this.props.showNotification("Le formulaire contient des erreurs. Veuillez vérifier les champs.", "danger");
            }
        }
    }

    render() {

        const productId = this.props.match.params.id;
        // ✅ CORRECTION: Même logique cohérente basée sur l'ID uniquement
        const isNew = !productId || productId === '0' || productId === 'new';


        try {
            // Si le produit n'est pas trouvé, afficher un message d'erreur spécifique
            if (this.state.showProductNotFoundError && this.state.productNotFoundId) {
                return (
                    <div className="main-content">
                        <Grid fluid>
                            <Row>
                                <Col sm={12}>
                                    <div style={{
                                        textAlign: 'center',
                                        padding: '40px 20px',
                                        backgroundColor: '#f8f9fa',
                                        borderRadius: '8px',
                                        border: '1px solid #dee2e6'
                                    }}>
                                        <div style={{
                                            fontSize: '60px',
                                            color: '#dc3545',
                                            marginBottom: '20px'
                                        }}>
                                            ❌
                                        </div>

                                        <h2 style={{
                                            color: '#dc3545',
                                            marginBottom: '15px'
                                        }}>
                                            Produit non trouvé
                                        </h2>

                                        <p style={{
                                            fontSize: '16px',
                                            color: '#6c757d',
                                            marginBottom: '15px',
                                            lineHeight: '1.5'
                                        }}>
                                            Le produit avec l'ID <strong>{this.state.productNotFoundId}</strong> n'existe pas
                                            ou a été supprimé de la base de données.
                                        </p>

                                        <p style={{
                                            fontSize: '14px',
                                            color: '#6c757d',
                                            marginBottom: '30px'
                                        }}>
                                            Vérifiez l'URL ou contactez l'administrateur si vous pensez qu'il s'agit d'une erreur.
                                        </p>

                                        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
                                            <Link to="/app/product/home">
                                                <Button bsStyle="primary" bsSize="lg" fill>
                                                    <i className="fa fa-arrow-left" style={{ marginRight: '8px' }} />
                                                    Retour à la liste des produits
                                                </Button>
                                            </Link>

                                            <Button
                                                bsStyle="default"
                                                bsSize="lg"
                                                onClick={() => this.props.history.goBack()}
                                            >
                                                <i className="fa fa-history" style={{ marginRight: '8px' }} />
                                                Page précédente
                                            </Button>
                                        </div>

                                        <div style={{
                                            marginTop: '30px',
                                            paddingTop: '20px',
                                            borderTop: '1px solid #dee2e6',
                                            fontSize: '12px',
                                            color: '#999'
                                        }}>
                                            <i className="fa fa-info-circle" style={{ marginRight: '5px' }} />
                                            Si vous avez accédé à cette page via un lien, celui-ci peut être obsolète.
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                );
            }

            return (
            <div className="main-content">
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <form onSubmit={this.onSubmit}>
                                <div style={{ marginBottom: '20px' }}>
                                    <Link to="/app/product/home">
                                        <Button bsSize="lg" fill>
                                            <i className="fa fa-arrow-left" style={{ marginRight: '8px' }} />
                                            Retour
                                        </Button>
                                    </Link>

                                    {this.props.product && this.props.product._id && (
                                        <Link
                                            style={{ marginLeft: '16px' }}
                                            to={`/app/product/field/lists/${this.props.product._id}`}
                                        >
                                            <Button bsStyle="info" bsSize="lg" fill>
                                                <i className="fa fa-list" style={{ marginRight: '8px' }} />
                                                Listes
                                            </Button>
                                        </Link>
                                    )}
                                </div>

                                {/* AJOUT: Message de succès en haut du formulaire */}
                                {this.state.showSuccessMessage && this.state.successMessage && (
                                    <div className="alert alert-success" role="alert" style={{
                                        animation: 'fadeInUp 0.5s',
                                        marginBottom: '20px',
                                        borderLeft: '4px solid #4CAF50',
                                        backgroundColor: '#f8fff8',
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '15px'
                                    }}>
                                        <i className="fa fa-check-circle" style={{
                                            fontSize: '24px',
                                            marginRight: '15px',
                                            color: '#4CAF50'
                                        }} />
                                        <div>
                                            <h4 style={{
                                                margin: '0 0 5px 0',
                                                color: '#2E7D32'
                                            }}>
                                                ✅ Enregistrement réussi !
                                            </h4>
                                            <p style={{ margin: 0 }}>
                                                {this.state.successMessage}
                                            </p>
                                            <p style={{
                                                margin: '10px 0 0 0',
                                                fontSize: '14px',
                                                opacity: 0.8
                                            }}>
                                                Redirection vers la liste des produits dans quelques secondes...
                                            </p>
                                        </div>
                                    </div>
                                )}

                                <h2>Informations de base</h2>
                                <ProductBaseForm
                                    state={this.state}
                                    setValue={this.setValue}
                                    loading={this.props.loading || this.state.loading}
                                />
                                {/* Debug: afficher les données passées */}
                                <div style={{
                                    background: '#f8f9fa',
                                    padding: '10px',
                                    margin: '10px 0',
                                    border: '1px solid #dee2e6',
                                    fontSize: '12px',
                                    fontFamily: 'monospace'
                                }}>
                                    <strong>DEBUG - Données passées à ProductBaseForm :</strong>
                                    <br />
                                    nom: {this.state.nom || 'VIDE'}
                                    <br />
                                    forme: {this.state.forme || 'VIDE'}
                                    <br />
                                    dosage: {this.state.dosage || 'VIDE'}
                                    <br />
                                    fabricant: {this.state.fabricant || 'VIDE'}
                                    <br />
                                    conditionnement: {this.state.conditionnement || 'VIDE'}
                                </div>

                                {this.state.isRef ? (
                                    <div>
                                        <h2>Informations pour les produits références</h2>
                                        <ProductReferenceForm
                                            state={this.state}
                                            setValue={this.setValue}
                                        />
                                    </div>
                                ) : null}

                                {this.state.formErrors && this.state.formErrors.length > 0 && (
                                    <div className="alert alert-danger">
                                        <h5 style={{ marginTop: 0 }}>❌ Erreurs de validation :</h5>
                                        <ul style={{ marginBottom: 0 }}>
                                            {this.state.formErrors.map((error, index) => (
                                                <li key={index}>{error}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}

                                <div className="text-center" style={{ marginTop: '30px' }}>
                                    <Button
                                        bsStyle="success"
                                        fill
                                        type="submit"
                                        style={{
                                            marginRight: '10px',
                                            borderRadius: '8px',
                                            padding: '12px 30px',
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            background: 'linear-gradient(135deg, #4CAF50 0%, #2E7D32 100%)',
                                            border: 'none',
                                            boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)'
                                        }}
                                        disabled={this.props.loading || this.state.loading}
                                    >
                                        <span className="btn-label" style={{marginRight: '8px'}}>
                                            {(this.props.loading || this.state.loading) ? (
                                                <i className="fa fa-spinner fa-spin"/>
                                            ) : (
                                                <i className="fa fa-save"/>
                                            )}
                                        </span>
                                        {isNew ? 'Créer le produit' : 'Enregistrer les modifications'}
                                    </Button>

                                    <Button
                                        bsStyle="danger"
                                        fill
                                        onClick={this.handleCancel}
                                        style={{
                                            borderRadius: '8px',
                                            padding: '12px 30px',
                                            fontSize: '16px',
                                            fontWeight: '600'
                                        }}
                                    >
                                        <i className="fa fa-times" style={{ marginRight: '8px' }} />
                                        Annuler
                                    </Button>
                                </div>
                            </form>
                        </Col>
                    </Row>
                </Grid>

                {/* Modal de confirmation de sauvegarde */}
                <DeleteConfirmationModal
                    show={this.state.showSaveConfirm}
                    onConfirm={this.confirmSave}
                    onCancel={() => this.setState({
                        showSaveConfirm: false,
                        formData: null
                    })}
                    itemName={isNew ? 'créer ce nouveau produit' : `enregistrer les modifications de "${this.props.product?.nom || this.state.nom || 'ce produit'}"`}
                    title={isNew ? "➕ Créer un nouveau produit" : "💾 Confirmer l'enregistrement"}
                    confirmLabel={isNew ? "Créer" : "Enregistrer"}
                    confirmStyle="success"
                    icon="save"
                    message={isNew
                        ? "Voulez-vous créer ce nouveau produit ?"
                        : `Voulez-vous enregistrer les modifications apportées à "${this.props.product?.nom || this.state.nom || 'ce produit'}" ?`
                    }
                    isIrreversible={false}
                />

                {/* Modal de confirmation d'annulation */}
                <DeleteConfirmationModal
                    show={this.state.showCancelConfirm}
                    onConfirm={() => {
                        this.setState({ showCancelConfirm: false });
                        this.props.history.goBack();
                    }}
                    onCancel={() => this.setState({ showCancelConfirm: false })}
                    itemName="annuler les modifications"
                    title="Confirmer l'annulation"
                    message="Les modifications non enregistrées seront perdues. Voulez-vous continuer ?"
                    confirmLabel="Oui, annuler"
                    confirmStyle="danger"
                    icon="times"
                />

                {/* AJOUT: Modal de confirmation de succès */}
                {this.state.showSuccessModal && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999
                    }}>
                        <div style={{
                            background: 'white',
                            borderRadius: '12px',
                            padding: '30px',
                            maxWidth: '500px',
                            width: '90%',
                            animation: 'fadeInUp 0.5s',
                            textAlign: 'center',
                            boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)'
                        }}>
                            <div style={{
                                fontSize: '60px',
                                color: '#4CAF50',
                                marginBottom: '20px'
                            }}>
                                ✅
                            </div>

                            <h3 style={{
                                color: '#2E7D32',
                                marginBottom: '15px'
                            }}>
                                {this.state.successModalTitle}
                            </h3>

                            <p style={{
                                fontSize: '16px',
                                color: '#333',
                                marginBottom: '25px',
                                lineHeight: '1.5'
                            }}>
                                {this.state.successModalMessage}
                            </p>

                            <p style={{
                                fontSize: '14px',
                                color: '#666',
                                marginBottom: '25px',
                                fontStyle: 'italic'
                            }}>
                                Redirection automatique dans 3 secondes...
                            </p>

                            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
                                <Button
                                    bsStyle="success"
                                    fill
                                    onClick={this.closeSuccessModal}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 25px',
                                        fontSize: '15px',
                                        fontWeight: '600',
                                        minWidth: '120px'
                                    }}
                                >
                                    <i className="fa fa-check" style={{ marginRight: '8px' }} />
                                    OK
                                </Button>

                                <Button
                                    bsStyle="primary"
                                    fill
                                    onClick={() => {
                                        this.setState({ showSuccessModal: false });
                                        // Ne pas rediriger, rester sur la page
                                    }}
                                    style={{
                                        borderRadius: '8px',
                                        padding: '10px 25px',
                                        fontSize: '15px',
                                        fontWeight: '600',
                                        minWidth: '120px'
                                    }}
                                >
                                    <i className="fa fa-home" style={{ marginRight: '8px' }} />
                                    Voir la liste
                                </Button>
                            </div>

                            <div style={{
                                marginTop: '20px',
                                paddingTop: '15px',
                                borderTop: '1px solid #eee',
                                fontSize: '12px',
                                color: '#999'
                            }}>
                                <i className="fa fa-info-circle" style={{ marginRight: '5px' }} />
                                Le produit a été enregistré dans la base de données
                            </div>
                        </div>
                    </div>
                )}
            </div>
            );
        } catch (error) {
            return (
                <div className="main-content">
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                        <h3>❌ Erreur de chargement</h3>
                        <p>Une erreur s'est produite lors du chargement de la page.</p>
                        <p>Erreur: {error.message}</p>
                        <Link to="/app/product/home">
                            <Button bsStyle="primary">
                                Retour à la liste des produits
                            </Button>
                        </Link>
                    </div>
                </div>
            );
        }
    }
}

ProductForm.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    message: PropTypes.object,
    loading: PropTypes.bool,
    product: PropTypes.object,
    error: PropTypes.string,
    getProductById: PropTypes.func,
    setProduct: PropTypes.func,
    newProduct: PropTypes.func,
    editProduct: PropTypes.func,
    showNotification: PropTypes.func,
    checkPendingUpdates: PropTypes.func,
    syncPendingProductUpdates: PropTypes.func
};

const mapStateToProps = state => {
    return {
        message: state.status.message,
        loading: state.status.loading,
        product: state.products.product,
        error: state.status.error
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getProductById: id => dispatch(getProductById(id)),
        setProduct: val => dispatch(setProduct(val)),
        newProduct: product => dispatch(newProduct(product)),
        editProduct: (productId, updateData) => dispatch(editProduct(productId, updateData)),
        checkPendingUpdates: () => dispatch(checkPendingUpdates()),
        syncPendingProductUpdates: () => dispatch(syncPendingProductUpdates())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ProductForm));

function getCleanedProduct(product) {
    if (!product || typeof product !== 'object') {
        return {};
    }

    const cleaned = {...product};

    // Gestion sécurisée du DCI
    cleaned.dciTags = cleaned.DCI
        ? cleaned.DCI.split(',').filter(val => val && val.trim())
        : [];

    // Gestion sécurisée des profils contre-indiqués
    if (cleaned.profilesContreIndiquees && typeof cleaned.profilesContreIndiquees === 'string') {
        cleaned.profilesContreIndiquees = cleaned.profilesContreIndiquees
            .split('$')
            .filter(val => val && val.trim())
            .map((val) => ({ label: val, value: val }));
    } else if (!Array.isArray(cleaned.profilesContreIndiquees)) {
        cleaned.profilesContreIndiquees = [];
    }

    // Gestion sécurisée des noms commerciaux contre-indiqués
    if (cleaned.nomCommercialContreIndique && typeof cleaned.nomCommercialContreIndique === 'string') {
        cleaned.nomCommercialContreIndique = cleaned.nomCommercialContreIndique
            .split('$')
            .filter(val => val && val.trim())
            .map((val) => ({ label: val, value: val }));
    } else if (!Array.isArray(cleaned.nomCommercialContreIndique)) {
        cleaned.nomCommercialContreIndique = [];
    }

    // Gestion sécurisée du statut médicament
    if (cleaned.statutMedicament && typeof cleaned.statutMedicament === 'string') {
        cleaned.statutMedicament = {
            label: cleaned.statutMedicament,
            value: cleaned.statutMedicament
        };
    } else if (!cleaned.statutMedicament || typeof cleaned.statutMedicament !== 'object') {
        cleaned.statutMedicament = null;
    }

    // Nettoyage des champs internes
    delete cleaned._id;
    delete cleaned.__v;
    delete cleaned.DCI;
    delete cleaned.createdAt;
    delete cleaned.updatedAt;

    return cleaned;
}